import { useEffect, useRef } from 'react';
import { useCloseCurrentContext } from '~/hooks/use-close-context';
import { useQDNotifications } from '../../utils/use-quick-deposit-hooks';
import ExecuteContextProvider from '~/components/payment-beta/deposit/context/execute';
import ExecuteStep from '~/components/payment-beta/components/execute';
import { ExecuteFlowType } from '~/components/payment-beta/utils/constants';
import { normalize } from '~/components/payment-beta/deposit/api/payment-execute';
import { deduceCustomProps, ExecuteHandlerPropsT, CustomPropsT } from './constants';
import { MAIN_CONTENT, LOADING } from '../../utils/constants';

const ExecuteResponseHandler = (props: ExecuteHandlerPropsT) => {
	const { result, updateViews, hideView } = props;
	const executeResponse = normalize(result ?? {});
	const { showErrorNotification } = useQDNotifications();
	const closeCurrentContext = useCloseCurrentContext();
	const handlerProps = useRef<CustomPropsT>(null);

	useEffect(() => {
		if (executeResponse?.successful) {
			handlerProps.current = deduceCustomProps(executeResponse, props);
		}
		updateViews(hideView(MAIN_CONTENT, LOADING));
	}, [executeResponse?.successful]); // eslint-disable-line react-hooks/exhaustive-deps

	if (executeResponse?.error) {
		const { message } = executeResponse?.errorMessage || {}; // TODO: verify errorMessage.message
		showErrorNotification(message);
		return closeCurrentContext();
	}

	if (handlerProps.current) {
		const handler = handlerProps.current;
		return (
			<ExecuteContextProvider
				value={{ data: executeResponse, actions: handler.actions, flow: ExecuteFlowType.QD }}
			>
				<ExecuteStep />
			</ExecuteContextProvider>
		);
	}
	return null;
};

export default ExecuteResponseHandler;
